const isUsernameValid = (type, username) => {
  // Check if the username type is valid
  if (!["retailGID", "email"].includes(type)) {
    console.error(`Invalid username type: ${type}`);
    return false;
  }

  // If validating email
  if (type === "email") {
    // Only these domains are allowed
    const validDomains = ["nike.com", "converse.com"];

    // Regular expression to validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check the general email format
    if (!emailRegex.test(username)) {
      return false;
    }

    // Check the domain
    const domain = username.split("@")[1];
    return validDomains.includes(domain);
  }

  // If validating retailGID
  if (type === "retailGID") {
    // Regular expressions for the specified patterns (case-insensitive with 'i' flag)
    const patterns = [
      /^A\.RN.+$/i, // A.RN followed by any characters (e.g., A.RN12345 or a.rn12345)
      /^A\.POS.+$/i, // A.POS followed by any characters (e.g., A.POS6789 or a.pos6789)
      /^S\.RN.+$/i, // S.RN followed by any characters (e.g., S.RN54321 or s.rn54321)
      /^S\.RT.+$/i, // S.RT followed by any characters (e.g., S.RT9876 or s.rt9876)
      /^A\.RT.+$/i, // A.RT followed by any characters (e.g., A.RT1357 or a.rt1357)
      /^R\..+$/i, // R. followed by any characters (e.g., R.STORE123 or r.store123)
    ];

    // Check if the username matches any of the allowed patterns
    return patterns.some((pattern) => pattern.test(username));
  }

  return false;
};

export default isUsernameValid;
